import { Body, FlexBox, Message } from '@Backlot-Cars/archie';
import { useTranslation } from 'next-i18next';
import { LookupActions } from './LookupActions';

export const AuctionAccessLookupError = ({ isUnavailable, onContinueManually, onTryAgain }) => {
	const { t } = useTranslation(['signup']);
	const errorKey = isUnavailable ? 'unavailable' : 'error';

	return (
		<FlexBox flexDirection="column" gap="lg">
			<Message iconName="exclamation" color="alert" iconColor="alert" borderColor="alert">
				<FlexBox flexDirection="column" gap="xs">
					<Body bold>{t(`signup:auctionAccessLookup.${errorKey}.title`)}</Body>
					<Body>{t(`signup:auctionAccessLookup.${errorKey}.subTitle`)}</Body>
				</FlexBox>
			</Message>
			<LookupActions
				onContinueManually={onContinueManually}
				onTryAgain={onTryAgain}
				tryAgainCopy={t('signup:auctionAccessLookup.notFound.tryAgain')}
				continueManuallyCopy={t('signup:auctionAccessLookup.entry.continueManually')}
			/>
		</FlexBox>
	);
};
